/** ItemList registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseItemList } from './parser';
const itemListRegistration = {
    typeName: 'ItemList',
    parser: parseItemList,
};
nodeRegistry.register(itemListRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map